const _temp0 = require("../node_modules/@b2c/core/app/components/linda/sport/linda-sport-field.js");

module.exports = {
  "linda":   {
    "sport": _temp0
  }
}